<template>
    <div class="the-email-dialog">
        <isc-dialog :title="title" :visible.sync="dialogVisible" append-to-body width="800px">
            <isc-form
                ref="form"
                :model="form"
                :rules="rules"
                label-width="100px"
                label-position="left"
                class="the-email-dialog__form"
            >
                <isc-form-item label="模板名称" prop="name">
                    <isc-input v-model="form.name"></isc-input>
                </isc-form-item>
                <isc-form-item label="Key" prop="key">
                    <isc-input v-model="form.key"></isc-input>
                </isc-form-item>
                <isc-form-item label="内容" prop="value">
                    <media-rich-editor v-model="form.value" :upload-method="uploadMethod" />
                </isc-form-item>
            </isc-form>
            <span slot="footer" class="dialog-footer">
                <isc-button @click="dialogVisible = false">取 消</isc-button>
                <isc-button type="primary" @click="handleSure">确 定</isc-button>
            </span>
        </isc-dialog>
    </div>
</template>

<script>
import axios from '@/utils/axios';
import { va } from '@isyscore/classes/validation';
import { MediaRichEditor } from '@isyscore/media-ui';

export default {
    name: 'Index',
    components: { MediaRichEditor },
    props: {
        formProp: {
            type: Object,
            default: () => {
                return {};
            }
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            form: {
                name: '',
                key: '',
                value: ''
            },
            rules: {
                name: va.required(),
                key: va.required(),
                value: va.required()
            },
            isClear: false,
            dialogVisible: false
        };
    },
    watch: {
        formProp: {
            handler(val) {
                this.form = val;
            },
            deep: true
        }
    },
    methods: {
        open() {
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },

        async uploadMethod(fd) {
            const fd2 = new FormData();
            fd2.append('file', fd.get('upload_file'));
            return await axios.post('/api/ops/config/common/upload', fd2);
        },

        async handleSure() {
            try {
                await this.$refs.form.validate();
            } catch (err) {
                return;
            }

            this.dialogVisible = false;
            this.$emit('onsure', this.form);
        }
    }
};
</script>

<style lang="scss" scoped>
.the-email-dialog {
    .isc-form.the-email-dialog__form {
        width: auto;
    }
    .isc-form {
        .form-title {
            font-weight: 600;
            ::v-deep .isc-form-item__label {
                font-size: 16px;
            }
        }
        &-item {
            ::v-deep .isc-form-item__label {
                color: #333333 !important;
            }

            .isc-textarea {
                ::v-deep .isc-textarea__inner {
                    height: 95px;
                    border: none;
                    background-color: #f5f5f5;
                }
            }

            .isc-button--text {
                ::v-deep i {
                    font-size: 16px;
                }
            }
        }
    }
}

.templateMsgBox {
    width: auto;
}
</style>
